angular.module('ihestiaRestServicesBase')
  .factory('customerPoliciesTerminableSvc', ['IHestiaRestServiceAbstractDef',
    function(IHestiaRestServiceAbstractDef) {

      var CustomerPoliciesTerminableSvc = function() {
        IHestiaRestServiceAbstractDef.apply(this, arguments);

        this.resource = 'customers';
        this.businessArea = 'insurance';
        this.searchesPostfix = 'policies/terminable/searches';

        this.sortBy = 'startDate';
      };

      return new CustomerPoliciesTerminableSvc();
    }]);